import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M19.2 11.2012a.7996.7996 0 0 0-.8.8 6.4401 6.4401 0 1 1-1.776-4.4h-1.92a.8.8 0 1 0 0 1.6h3.624a.8.8 0 0 0 .8-.8v-3.6a.8.8 0 0 0-1.6 0v1.416A8.0001 8.0001 0 0 0 4.6437 15.144 8.0001 8.0001 0 0 0 20 12.0012a.8.8 0 0 0-.8-.8"
}), "Redo", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
